/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//import TimePicker from '@ashwinthomas/react-time-picker-dropdown';
//https://www.npmjs.com/package/@ashwinthomas/react-time-picker-dropdown

// looks good
// https://www.npmjs.com/package/react-accessible-time-picker

// suggest improvements for this component
// give me the entire code to copy
//ran this thru claudes code refactoring tool



//apply same styling to this component as the EventDetails component


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { FiSave } from 'react-icons/fi';
import { TbListDetails } from 'react-icons/tb';

import {
    update_event_details_not_deposit,
    get_event_details,
    messageClear,
} from '../../store/reducers/eventDetailsReducer';
import { get_sellerPackages_webSiteOrigin } from '../../store/reducers/sellerPackageReducer';

import GetSellerConfig from '../GetSellerConfig';
import DiagnosticInfo from '../DiagnosticInfo';

import toast from 'react-hot-toast';
import config from '../../config';

// ---------------------------------------------------------------------------
// Shared styled primitives (mirrors EventDetails)
// ---------------------------------------------------------------------------

const fieldBase =
    'w-full px-3 py-2 rounded-md border bg-white text-sm transition-all duration-200 outline-none placeholder-gray-300';

const StyledInput = ({ colorDark, colorMedium, colorLight, ...props }) => (
    <input
        {...props}
        className={fieldBase}
        style={{ 
            borderColor: colorMedium , 
            color: colorDark, 
            backgroundColor: 'white'
        }}
        onFocus={e => {
            e.target.style.borderColor = colorDark;
            e.target.style.backgroundColor = colorLight;
            //e.target.style.boxShadow = `0 0 0 3px ${colorDark}20`;
        }}
        onBlur={e => {
            e.target.style.borderColor = colorMedium;
            e.target.style.backgroundColor = 'white';
            //e.target.style.boxShadow = 'none';
        }}
    />
);

const StyledSelect = ({ colorDark, colorMedium, colorLight, children, ...props }) => (
    <select
        {...props}
        className={fieldBase + ' cursor-pointer'}
        style={{ 
            borderColor: colorMedium, 
            color: colorDark, 
            backgroundColor: 'white',
            height: '38px' 
        }}
        onFocus={e => {
            e.target.style.borderColor = colorDark;
            e.target.style.backgroundColor = colorLight;
            //e.target.style.boxShadow = `0 0 0 3px ${colorDark}20`;
        }}
        onBlur={e => {
            e.target.style.borderColor = colorMedium;
            e.target.style.backgroundColor = 'white';
            //e.target.style.boxShadow = 'none';
        }}>
        {children}
    </select>
);

const StyledTextarea = ({ colorDark, colorMedium, colorLight, ...props }) => (
    <textarea
        {...props}
        className={fieldBase + ' h-[110px] resize-none'}
        style={{ 
            color: colorDark, 
            backgroundColor: 'white',
        }}
        onFocus={e => {
            e.target.style.borderColor = colorDark;
            e.target.style.backgroundColor = colorLight;
            //e.target.style.boxShadow = `0 0 0 3px ${colorDark}20`;
        }}
        onBlur={e => {
            e.target.style.borderColor = colorMedium;
            e.target.style.backgroundColor = 'white';
            //e.target.style.boxShadow = 'none';
        }}
    />
);

const Field = ({ label, children }) => (
    <div className='flex flex-col gap-1 w-full'>
        <label className='text-[12px] font-semibold uppercase tracking-wider opacity-80'>
            {label}
        </label>
        {children}
    </div>
);

const SectionHeading = ({ label, color }) => (
    <div className='flex items-center gap-3 mt-5 mb-3'>
        <span
            className='text-[11px] font-bold uppercase tracking-widest whitespace-nowrap'
            style={{ color: color }}>
            {label}
        </span>
        <div className='flex-1 h-px' style={{ backgroundColor: color }} />
    </div>
);

const ColorSelect = ({ label, name, value, onChange, colors, colorDark, colorMedium, colorLight, }) => (
    <Field label={label}>
        <StyledSelect colorDark={colorDark} colorMedium={colorMedium} colorLight={colorLight}
            onChange={onChange} value={value ?? ''} name={name} id={name}>
            <option value="">{label}</option>
            <option value="None">None</option>
            {colors?.split(';').sort().map((c, i) => (
                <option key={i} value={c}>{c}</option>
            ))}
        </StyledSelect>
    </Field>
);

// ---------------------------------------------------------------------------
// Initial state
// ---------------------------------------------------------------------------

const INITIAL_STATE = {
    depositGiven: false,
    depositAmountPaid: 0,
    balanceGiven: false,
    balanceAmountPaid: 0,
    eventName: '',
    selectedSellerPackage: 'None',
    venueName: '',
    venueAddress: '',
    eventType: '',
    eventDate: '',
    eventStartTime: '',
    eventServiceType: '',
    eventPlaceSettings: '',
    eventGuestTableclothColor: '',
    eventBuffetTableclothColor: '',
    eventNapkinColor: '',
    venueManagerContactInfo: '',
    venueDoorCode: '',
    eventGuestCount: 0,
    eventNotes: '',
};

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

const EventDetailsCustomerDashboard = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;
    const sellerEnvironment = config.STR_ENVIRONMENT;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userInfo } = useSelector((state) => state.auth);
    const { eventDetails, errorMessage, successMessage } = useSelector((state) => state.eventDetails);
    const { sellerPackages } = useSelector((state) => state.sellerPackage);

    const {
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2,
        sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight,
        sellerClothColors, sellerMinGuestCount, sellerServiceTypes,
        sellerPlaceSettings, sellerBoolShowSitePayments, sellerCateringLocationList, 
        sellerBoolRestrictCustomerToCateringLocations, sellerEventTypeList
    } = GetSellerConfig();

    //console.log('sellerCateringLocationList:', sellerCateringLocationList);
    //const sellerArrSellerLocationList = sellerCateringLocationList.split(';') || []; // Split the location list into an array, or use an empty array if undefined   
    //const sellerArrSellerLocationList = (sellerCateringLocationList ?? '').split(';');
    //const sellerArrSellerLocationList = sellerCateringLocationList ? sellerCateringLocationList.split(';') : [];
    const sellerArrCateringLocationList = sellerCateringLocationList?.split(';') ?? [];
    
    const sellerArrEventTypes = [
        ...new Set(
            (sellerEventTypeList ?? '')
                .split(';')
                .map((et) => et.trim())
                .filter((et) => et.length > 0)
        ),
    ];
        
    const [state, setState] = useState(INITIAL_STATE);
    const [eventDetailsSaved, setEventDetailsSaved] = useState(true);

    useEffect(() => {
        dispatch(get_event_details(userInfo.id));
    }, [userInfo.id]);

    useEffect(() => {
        dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL));
    }, []);

    useEffect(() => {
        if (eventDetails) {
            setState({
                depositGiven: eventDetails.depositGiven ?? '',
                eventName: eventDetails.eventName ?? '',
                selectedSellerPackage: eventDetails.selectedSellerPackage ?? 'None',
                venueName: eventDetails.venueName ?? '',
                venueAddress: eventDetails.venueAddress ?? '',
                eventType: eventDetails.eventType ?? '',
                eventDate: eventDetails.eventDate ?? '',
                eventStartTime: eventDetails.eventStartTime ?? '',
                eventServiceType: eventDetails.eventServiceType ?? '',
                eventPlaceSettings: eventDetails.eventPlaceSettings ?? '',
                eventGuestTableclothColor: eventDetails.eventGuestTableclothColor ?? '',
                eventBuffetTableclothColor: eventDetails.eventBuffetTableclothColor ?? '',
                eventNapkinColor: eventDetails.eventNapkinColor ?? '',
                venueManagerContactInfo: eventDetails.venueManagerContactInfo ?? '',
                venueDoorCode: eventDetails.venueDoorCode ?? '',
                eventGuestCount: eventDetails.eventGuestCount ?? 0,
                eventNotes: eventDetails.eventNotes ?? '',
            });
        }
    }, [eventDetails]);

    useEffect(() => {
        if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
        if (errorMessage) { toast.error(errorMessage); dispatch(messageClear()); }
    }, [successMessage, errorMessage]);

    const inputHandle = (e) => {
        setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        setEventDetailsSaved(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!userInfo) { navigate('/login'); return; }
        const { depositGiven, ...rest } = state;
        dispatch(update_event_details_not_deposit({ customerId: userInfo.id, ...rest }));
        setEventDetailsSaved(true);
    };

    const colorDark = sellerPrimaryColor1 + sellerColorSuffixDark;
    const colorMedium = sellerPrimaryColor1 + sellerColorSuffixMedium;
    const colorLight = sellerPrimaryColor1 + sellerColorSuffixLight;
    
    return (
        <div
            className='rounded-xl shadow-sm overflow-hidden border bg-white'
            style={{ 
                borderColor: colorDark,
            }}>
            {/* Panel header */}
            <div
                className='flex items-center justify-between px-6 py-3'
                style={{ 
                    borderBottom: `1px solid ${colorMedium}`, 
                    backgroundColor: colorLight,
                }}>
                <div className='flex items-center gap-2 mb-1'>
                    <div>
                        <TbListDetails size={32} style={{ color: colorDark }} />
                    </div>
                    <div>
                        <div
                            className="text-2xl font-bold tracking-tight leading-none"
                            style={{ color: colorDark }}>
                            Event Details
                        </div>
                    </div>
                </div>

                <div className='flex items-center gap-3'>
                    <DiagnosticInfo parentPage={'EventDetailsCustomerDashboard.jsx'} />
                    
                    {/* Save status pill */}
                    <div
                        className={`inline-flex items-center gap-1 px-2 py-1.5 rounded-full text-[12px] 
                            font-semibold transition-colors duration-300 
                            ${eventDetailsSaved
                                ? 'bg-green-100 text-green-500 border-2 border-green-500'
                                : 'bg-red-100 text-red-500 border-2 border-red-500'
                            }`}>
                        <FiSave size={15} />
                        {eventDetailsSaved ? 'Event Details Saved' : 'Unsaved Changes'}
                    </div>
                </div>
            </div>

            {/* Form body */}
            <div className='px-6 py-5' style={{ color: colorDark }}>
                <form onSubmit={handleSubmit}>
                    {/* ── Event Identity ── */}
                    <SectionHeading label="Event Identity" color={colorMedium} />
                    <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                        <Field label="Event Name">
                            <StyledInput
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                required
                                onChange={inputHandle} value={state.eventName ?? ''}
                                name="eventName" id="eventName" type="text"
                                placeholder="e.g. Bar Mitzvah of Ari Cohen"
                            />
                        </Field>
                        <Field label="Package">
                            <StyledSelect
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.selectedSellerPackage ?? 'None'}
                                name="selectedSellerPackage" id="selectedSellerPackage">
                                <option value="None">Choose Package / No Package</option>
                                {sellerPackages.map((item, i) => (
                                    <option key={i} value={item.title}>{item.title}</option>
                                ))}
                            </StyledSelect>
                        </Field>
                        <Field label="Event Type">
                            <StyledSelect
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                required
                                onChange={inputHandle} value={state.eventType ?? ''}
                                name="eventType" id="eventType">
                                <option value="">Event Type</option>
                                {sellerArrEventTypes.sort().map((ev, i) => (
                                    <option key={i} value={ev}>{ev}</option>
                                ))}
                            </StyledSelect>
                        </Field>
                    </div>

                    {/* ── Venue ── */}
                    <SectionHeading label="Venue" color={colorMedium} />
                    <div className='grid grid-cols-4 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                        <Field label="Venue Name">
                            <div className={` ${sellerBoolRestrictCustomerToCateringLocations ? '' : '' } `}>
                                <StyledInput
                                    colorDark={colorDark}
                                    colorMedium={colorMedium}
                                    colorLight={colorLight}
                                    onChange={inputHandle} value={state.venueName ?? ''}
                                    name="venueName" id="venueName" type="text"
                                    placeholder="e.g. Cong Adath Israel"
                                />
                            </div>
                            <div className={` ${sellerBoolRestrictCustomerToCateringLocations ? 'hidden' : 'hidden' } `}>
                                <StyledSelect
                                    colorDark={colorDark}
                                    colorMedium={colorMedium}
                                    colorLight={colorLight}
                                    onChange={inputHandle} value={state.venueName ?? ''}
                                    name="venueName" id="venueName">
                                    <option value="">Venue Name</option>
                                    {sellerArrCateringLocationList.sort().map((ev, i) => (
                                        <option key={i} value={ev}>{ev}</option>
                                    ))}
                                </StyledSelect>
                            </div>
                        </Field>
                        <Field label="Venue Address">
                            <StyledInput
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.venueAddress ?? ''}
                                name="venueAddress" id="venueAddress" type="text"
                                placeholder="Full address, city, state, zip"
                            />
                        </Field>
                        <Field label="Venue Manager">
                            <StyledInput
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.venueManagerContactInfo ?? ''}
                                name="venueManagerContactInfo" id="venueManagerContactInfo"
                                type="text" placeholder="Name / Phone or N/A"
                            />
                        </Field>
                        <Field label="Door Code">
                            <StyledInput
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.venueDoorCode ?? ''}
                                name="venueDoorCode" id="venueDoorCode"
                                type="text" placeholder="If applicable"
                            />
                        </Field>
                    </div>
                    
                    {/* ── Date & Service ── */}
                    <SectionHeading label="Date & Service" color={colorMedium} />
                    <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                        <Field label="Event Date">
                            <StyledInput
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.eventDate ?? ''}
                                name="eventDate" id="eventDate" type="date"
                            />
                        </Field>
                        <Field label="Start Time">
                            <StyledInput
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.eventStartTime ?? ''}
                                name="eventStartTime" id="eventStartTime" type="time"
                            />
                        </Field>
                        <Field label={`Guest Count${sellerMinGuestCount !== '1' ? ` (Min ${sellerMinGuestCount})` : ''}`}>
                            <StyledInput
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.eventGuestCount ?? 0}
                                type="number" min={sellerMinGuestCount}
                                name="eventGuestCount" id="eventGuestCount"
                                placeholder="Number of guests"
                            />
                        </Field>
                    </div>
                    <div className='grid grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                        <Field label="Place Settings">
                            <StyledSelect
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.eventPlaceSettings ?? ''}
                                name="eventPlaceSettings" id="eventPlaceSettings">
                                <option value="">Place Settings</option>
                                {sellerPlaceSettings?.split(';').map((s, i) => (
                                    <option key={i} value={s}>{s}</option>
                                ))}
                            </StyledSelect>
                        </Field>
                        <Field label="Service Type">
                            <StyledSelect
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.eventServiceType ?? ''}
                                name="eventServiceType" id="eventServiceType">
                                <option value="">Service Type</option>
                                {sellerServiceTypes?.split(';').map((s, i) => (
                                    <option key={i} value={s}>{s}</option>
                                ))}
                            </StyledSelect>
                        </Field>
                    </div>

                    {/* ── Table & Linen ── */}
                    <SectionHeading label="Table & Linen" color={colorMedium} />
                    <div className='grid grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-4 mb-2'>
                        <ColorSelect
                            label="Guest Tablecloth Color"
                            name="eventGuestTableclothColor"
                            value={state.eventGuestTableclothColor}
                            onChange={inputHandle}
                            colors={sellerClothColors}
                            colorDark={colorDark}
                            colorMedium={colorMedium}
                            colorLight={colorLight}
                        />
                        <ColorSelect
                            label="Buffet Tablecloth Color"
                            name="eventBuffetTableclothColor"
                            value={state.eventBuffetTableclothColor}
                            onChange={inputHandle}
                            colors={sellerClothColors}
                            colorDark={colorDark}
                            colorMedium={colorMedium}
                            colorLight={colorLight}
                        />
                        <ColorSelect
                            label="Napkin Color"
                            name="eventNapkinColor"
                            value={state.eventNapkinColor}
                            onChange={inputHandle}
                            colors={sellerClothColors}
                            colorDark={colorDark}
                            colorMedium={colorMedium}
                            colorLight={colorLight}    
                        />
                    </div>

                    {/* ── Notes ── */}
                    <SectionHeading label="Notes" color={colorMedium} />
                    <div className='mb-2'>
                        <Field label="My Notes (Optional)">
                            <StyledTextarea
                                colorDark={colorDark}
                                colorMedium={colorMedium}
                                colorLight={colorLight}
                                onChange={inputHandle} value={state.eventNotes ?? ''}
                                name="eventNotes" id="eventNotes"
                                placeholder="Food sensitivities, special requests, anything else we should know…"
                            />
                        </Field>
                    </div>

                    {/* ── Submit ── */}
                    <div className='mt-6'>
                        <button
                            type="submit"
                            className='inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-white text-md font-semibold tracking-wide
                                transition-all duration-200 hover:opacity-90 hover:shadow-md active:scale-[0.98]'
                            style={{ backgroundColor: colorDark }}>
                            <FiSave size={20} />
                            Save Event Details
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EventDetailsCustomerDashboard;





//refactored before redesign
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FiSave } from 'react-icons/fi';
// import { TbListDetails } from 'react-icons/tb';

// import {
//     update_event_details_not_deposit,
//     get_event_details,
//     messageClear,
// } from '../../store/reducers/eventDetailsReducer';
// import { get_sellerPackages_webSiteOrigin } from '../../store/reducers/sellerPackageReducer';

// import GetSellerConfig from '../GetSellerConfig';
// import GiveDepositComponent from '../GiveDepositComponent';
// import toast from 'react-hot-toast';
// import config from '../../config';

// // ---------------------------------------------------------------------------
// // Small reusable helpers
// // ---------------------------------------------------------------------------

// const FormField = ({ label, htmlFor, children }) => (
//     <div className="flex flex-col gap-1 mb-2 w-full">
//         <label className="font-semibold text-[14px]" htmlFor={htmlFor}>
//             {label}
//         </label>
//         {children}
//     </div>
// );

// const inputCls =
//     'w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md';
// const selectCls =
//     'w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md';

// /** Reusable color <select> for tablecloth / napkin fields */
// const ColorSelect = ({ label, name, value, onChange, colors }) => (
//     <FormField label={label} htmlFor={name}>
//         <select
//             onChange={onChange}
//             value={value ?? ''}
//             name={name}
//             id={name}
//             className={selectCls}>
//             <option value="">{label}</option>
//             <option value="None">None</option>
//             {colors
//                 ?.split(';')
//                 .sort()
//                 .map((c, i) => (
//                     <option key={i} value={c}>
//                         {c}
//                     </option>
//                 ))}
//         </select>
//     </FormField>
// );

// // ---------------------------------------------------------------------------
// // Initial form state (all keys in one place)
// // ---------------------------------------------------------------------------

// const INITIAL_STATE = {
//     depositGiven: '',
//     eventName: '',
//     selectedSellerPackage: 'None',
//     venueName: '',
//     venueAddress: '',
//     eventType: '',
//     eventDate: '',
//     eventStartTime: '',
//     eventServiceType: '',
//     eventPlaceSettings: '',
//     eventGuestTableclothColor: '',
//     eventBuffetTableclothColor: '',
//     eventNapkinColor: '',
//     venueManagerContactInfo: '',
//     venueDoorCode: '',
//     eventGuestCount: 0,
//     eventNotes: '',
// };

// // ---------------------------------------------------------------------------
// // Component
// // ---------------------------------------------------------------------------

// const EventDetailsCustomerDashboard = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const sellerArrEventTypes = config.;
//     const sellerEnvironment = config.STR_ENVIRONMENT;

//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const { userInfo } = useSelector((state) => state.auth);
//     const { eventDetails, errorMessage, successMessage } = useSelector(
//         (state) => state.eventDetails
//     );
//     //const { seller } = useSelector((state) => state.seller);
//     const { sellerPackages } = useSelector((state) => state.sellerPackage);

//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, 
//         sellerClothColors, sellerMinGuestCount, sellerServiceTypes, sellerPlaceSettings, 
//         sellerBoolShowSitePayments, 
//     } = GetSellerConfig();

//     const [state, setState] = useState(INITIAL_STATE);
//     const [eventDetailsSaved, setEventDetailsSaved] = useState(true);

//     // Fetch event details for this customer
//     useEffect(() => {
//         dispatch(get_event_details(userInfo.id));
//     }, [userInfo.id]);

//     // Fetch seller packages
//     useEffect(() => {
//         dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL));
//     }, []);

//     // Sync redux eventDetails → local form state
//     useEffect(() => {
//         if (eventDetails) {
//             setState({
//                 depositGiven: eventDetails.depositGiven ?? '',
//                 eventName: eventDetails.eventName ?? '',
//                 selectedSellerPackage: eventDetails.selectedSellerPackage ?? 'None',
//                 venueName: eventDetails.venueName ?? '',
//                 venueAddress: eventDetails.venueAddress ?? '',
//                 eventType: eventDetails.eventType ?? '',
//                 eventDate: eventDetails.eventDate ?? '',
//                 eventStartTime: eventDetails. ?? '',
//                 eventServiceType: eventDetails.eventServiceType ?? '',
//                 eventPlaceSettings: eventDetails.eventPlaceSettings ?? '',
//                 eventGuestTableclothColor: eventDetails.eventGuestTableclothColor ?? '',
//                 eventBuffetTableclothColor: eventDetails.eventBuffetTableclothColor ?? '',
//                 eventNapkinColor: eventDetails.eventNapkinColor ?? '',
//                 venueManagerContactInfo: eventDetails.venueManagerContactInfo ?? '',
//                 venueDoorCode: eventDetails.venueDoorCode ?? '',
//                 eventGuestCount: eventDetails.eventGuestCount ?? 0,
//                 eventNotes: eventDetails.eventNotes ?? '',
//             });
//         }
//     }, [eventDetails]);

//     // Toast notifications
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage]);

//     const inputHandle = (e) => {
//         setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//         setEventDetailsSaved(false);
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         if (!userInfo) {
//             navigate('/login');
//             return;
//         }
//         const { depositGiven, ...rest } = state; // depositGiven is not sent here
//         dispatch(
//             update_event_details_not_deposit({
//                 customerId: userInfo.id,
//                 ...rest,
//             })
//         );
//         setEventDetailsSaved(true);
//     };

//     return (
//         <div>
//             <div
//                 className="border p-4 rounded-md"
//                 style={{
//                     backgroundColor: sellerSecondaryColor1,
//                     color: sellerPrimaryColor1,
//                     borderColor: sellerPrimaryColor1,
//                 }}
//             >
//                 <form onSubmit={handleSubmit}>
//                     {/* ── Header row ── */}
//                     <div
//                         className="flex md:flex-col md:gap-2 w-full mb-2"
//                         style={{ color: sellerPrimaryColor1 }}
//                     >
//                         <div className="text-2xl flex font-bold">
//                             <TbListDetails className="mt-1 mr-1" />
//                             Event Details
//                         </div>

//                         {/* Saved / unsaved indicator */}
//                         <div
//                             className={`${
//                                 eventDetailsSaved
//                                     ? 'bg-green-200 border-green-600'
//                                     : 'bg-red-200 border-red-600'
//                             } flex ml-2 mt-1 pl-2 pr-2 h-[30px] items-center border rounded-lg`}
//                         >
//                             <button
//                                 type="button"
//                                 title="Save status"
//                                 className="pr-0 flex items-center rounded"
//                             >
//                                 <FiSave className="mr-1" size={20} />
//                                 {eventDetailsSaved ? (
//                                     <span className="text-[12px] text-green-600 font-bold">
//                                         Event Details Saved
//                                     </span>
//                                 ) : (
//                                     <span className="text-[12px] text-red-600 font-bold">
//                                         Save Event Details
//                                     </span>
//                                 )}
//                             </button>
//                         </div>

//                         {/* Dev-only debug info */}
//                         {sellerEnvironment === 'Dev' && (
//                             <div className="text-[12px] ml-2 text-gray-500">
//                                 <div>eventDetails?._id</div>
//                                 <div>&quot;_id&quot;: ObjectId(&quot;{eventDetails?._id}&quot;)</div>
//                                 <div>
//                                     sellerBoolShowSitePayments:{' '}
//                                     {sellerBoolShowSitePayments.toString()}
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     {/* ── Row 1: name / package / venue ── */}
//                     <div className="flex md:flex-col md:gap-2 w-full gap-2" style={{ color: sellerPrimaryColor1 }}>
//                         <FormField label="Event Name" htmlFor="eventName">
//                             <input
//                                 required
//                                 onChange={inputHandle}
//                                 value={state.eventName ?? ''}
//                                 name="eventName"
//                                 id="eventName"
//                                 type="text"
//                                 placeholder="Event Name e.g The Bar Mitzvah Of Ari Cohen"
//                                 className={inputCls}
//                             />
//                         </FormField>

//                         <FormField label="Package" htmlFor="selectedSellerPackage">
//                             <select
//                                 required
//                                 onChange={inputHandle}
//                                 value={state.selectedSellerPackage ?? 'None'}
//                                 name="selectedSellerPackage"
//                                 id="selectedSellerPackage"
//                                 className={selectCls}
//                             >
//                                 <option value="None">Choose Package / No Package</option>
//                                 {sellerPackages.map((item, i) => (
//                                     <option key={i} value={item.title}>
//                                         {item.title}
//                                     </option>
//                                 ))}
//                             </select>
//                         </FormField>

//                         <FormField label="Venue Name" htmlFor="venueName">
//                             <input
//                                 onChange={inputHandle}
//                                 value={state.venueName ?? ''}
//                                 name="venueName"
//                                 id="venueName"
//                                 type="text"
//                                 placeholder="Venue Name e.g Cong Adath Israel"
//                                 className={inputCls}
//                             />
//                         </FormField>

//                         <FormField label="Venue Address" htmlFor="venueAddress">
//                             <input
//                                 onChange={inputHandle}
//                                 value={state.venueAddress ?? ''}
//                                 name="venueAddress"
//                                 id="venueAddress"
//                                 type="text"
//                                 placeholder="Venue Full Address, City, State, Zipcode"
//                                 className={inputCls}
//                             />
//                         </FormField>
//                     </div>

//                     {/* ── Row 2: venue contact / date / time ── */}
//                     <div className="flex md:flex-col md:gap-2 w-full gap-2" style={{ color: sellerPrimaryColor1 }}>
//                         <FormField label="Venue Manager" htmlFor="venueManagerContactInfo">
//                             <input
//                                 onChange={inputHandle}
//                                 value={state.venueManagerContactInfo ?? ''}
//                                 name="venueManagerContactInfo"
//                                 id="venueManagerContactInfo"
//                                 placeholder="Name/Phone Or N/A"
//                                 type="text"
//                                 className={inputCls}
//                             />
//                         </FormField>

//                         <FormField label="Venue Door Code" htmlFor="venueDoorCode">
//                             <input
//                                 onChange={inputHandle}
//                                 value={state.venueDoorCode ?? ''}
//                                 name="venueDoorCode"
//                                 id="venueDoorCode"
//                                 placeholder="Venue Door Code"
//                                 type="text"
//                                 className={inputCls}
//                             />
//                         </FormField>

//                         <FormField label="Date" htmlFor="eventDate">
//                             <input
//                                 onChange={inputHandle}
//                                 value={state.eventDate ?? ''}
//                                 name="eventDate"
//                                 id="eventDate"
//                                 type="date"
//                                 className={inputCls}
//                             />
//                         </FormField>

//                         <FormField label="Start Time" htmlFor="">
//                             <input
//                                 onChange={inputHandle}
//                                 value={state.eventStartTime ?? ''}
//                                 type="time"
//                                 name="eventStartTime"
//                                 id="eventStartTime"
//                                 className={inputCls}
//                             />
//                         </FormField>
//                     </div>

//                     {/* ── Row 3: event / service / place settings ── */}
//                     <div className="flex md:flex-col md:gap-2 w-full gap-2" style={{ color: sellerPrimaryColor1 }}>
//                         <FormField label="Event Type" htmlFor="eventType">
//                             <select
//                                 required
//                                 onChange={inputHandle}
//                                 value={state.eventType ?? ''}
//                                 name="eventType"
//                                 id="eventType"
//                                 className={selectCls}
//                             >
//                                 <option value="">Event Type</option>
//                                 {sellerArrEventTypes.sort().map((p, i) => (
//                                     <option key={i} value={p}>
//                                         {p}
//                                     </option>
//                                 ))}
//                             </select>
//                         </FormField>

//                         <FormField label="Service Type" htmlFor="eventServiceType">
//                             <select
//                                 onChange={inputHandle}
//                                 value={state.eventServiceType ?? ''}
//                                 name="eventServiceType"
//                                 id="eventServiceType"
//                                 className={selectCls}
//                             >
//                                 <option value="">Service Type</option>
//                                 {sellerServiceTypes?.split(';').map((p, i) => (
//                                     <option key={i} value={p}>
//                                         {p}
//                                     </option>
//                                 ))}
//                             </select>
//                         </FormField>

//                         <FormField label="Place Settings" htmlFor="eventPlaceSettings">
//                             <select
//                                 onChange={inputHandle}
//                                 value={state.eventPlaceSettings ?? ''}
//                                 name="eventPlaceSettings"
//                                 id="eventPlaceSettings"
//                                 className={selectCls}
//                             >
//                                 <option value="">Place Settings</option>
//                                 {sellerPlaceSettings?.split(';').map((p, i) => (
//                                     <option key={i} value={p}>
//                                         {p}
//                                     </option>
//                                 ))}
//                             </select>
//                         </FormField>
//                     </div>

//                     {/* ── Row 4: colors / guest count ── */}
//                     <div className="flex md:flex-col md:gap-2 w-full gap-2" style={{ color: sellerPrimaryColor1 }}>
//                         <ColorSelect
//                             label="Guest Tablecloth Color"
//                             name="eventGuestTableclothColor"
//                             value={state.eventGuestTableclothColor}
//                             onChange={inputHandle}
//                             colors={sellerClothColors}
//                         />
//                         <ColorSelect
//                             label="Buffet Tablecloth Color"
//                             name="eventBuffetTableclothColor"
//                             value={state.eventBuffetTableclothColor}
//                             onChange={inputHandle}
//                             colors={sellerClothColors}
//                         />
//                         <ColorSelect
//                             label="Napkin Color"
//                             name="eventNapkinColor"
//                             value={state.eventNapkinColor}
//                             onChange={inputHandle}
//                             colors={sellerClothColors}
//                         />

//                         <FormField
//                             label={
//                                 <>
//                                     Guest Count{' '}
//                                     {sellerMinGuestCount !== '1' && (
//                                         <span className="font-normal ml-1">(Min {sellerMinGuestCount})</span>
//                                     )}
//                                 </>
//                             }
//                             htmlFor="eventGuestCount"
//                         >
//                             <input
//                                 onChange={inputHandle}
//                                 value={state.eventGuestCount ?? 0}
//                                 type="number"
//                                 min={sellerMinGuestCount}
//                                 name="eventGuestCount"
//                                 id="eventGuestCount"
//                                 placeholder="How Many People Are Coming?"
//                                 className={inputCls}
//                             />
//                         </FormField>
//                     </div>

//                     {/* ── Notes ── */}
//                     <div className="flex md:flex-col md:gap-2 w-full gap-5" style={{ color: sellerPrimaryColor1 }}>
//                         <div className="flex flex-col gap-1 mb-2 w-full">
//                             <label className="font-bold" htmlFor="eventNotes">
//                                 My Notes (Optional)
//                             </label>
//                             <textarea
//                                 onChange={inputHandle}
//                                 value={state.eventNotes ?? ''}
//                                 name="eventNotes"
//                                 id="eventNotes"
//                                 placeholder="Is there anything else we need to know? Any food sensitivities or preferences?"
//                                 className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md"
//                             />
//                         </div>
//                     </div>

//                     {/* ── Submit ── */}
//                     <div className="flex flex-col gap-1 mt-3 mb-2 w-full">
//                         <button
//                             type="submit"
//                             className="flex px-3 py-[6px] rounded-lg font-bold text-lg text-white items-center justify-center"
//                             style={{ backgroundColor: sellerPrimaryColor1 }}
//                         >
//                             <TbListDetails size={24} className="mr-1" />
//                             Save Event Details
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default EventDetailsCustomerDashboard;





//my original code
// import React, { useEffect, useState } from 'react';
// import {  useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaCircleCheck } from "react-icons/fa6";
// import { FaCheck } from "react-icons/fa";
// import { CiCircleCheck } from "react-icons/ci";
// import { FiSave } from 'react-icons/fi';
// import { TbListDetails } from "react-icons/tb";

// import { update_event_details, update_event_details_not_deposit, get_event_details, messageClear } from '../../store/reducers/eventDetailsReducer';
// import { get_sellerPackages_webSiteOrigin } from '../../store/reducers/sellerPackageReducer';

// import GiveDepositComponent from '../GiveDepositComponent';
// import toast from 'react-hot-toast';


// import config from '../../config';

// const EventDetailsCustomerDashboard = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const sellerArrEventTypes = config.STR_ARR_FRONTEND_EVENT_TYPES
//     const sellerEnvironment = config.STR_ENVIRONMENT

//     const { loader,  userInfo } = useSelector(state => state.auth);
//     const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
//     const { seller } = useSelector(state => state.seller)
//     const { sellerPackages, totalSellerPackage } = useSelector(state => state.sellerPackage)

//     useEffect(() => {
//         dispatch(get_event_details(userInfo.id))
//         // console.log('dispatch get_event_details ', userInfo.id)
//         // console.log('eventDetails ', eventDetails)
//     },[userInfo.id])
    
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
     
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
//     const sellerPrimaryColor2 =  seller.frontEndPrimaryColor2
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
//     const sellerServiceTypes = seller.serviceTypes
//     const sellerPlaceSettings = seller.placeSettings
//     const sellerArrClothColors = seller.clothColors
//     const sellerMinGuestCount = seller.minGuestCount
//     const sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false

//     const [eventDetailsSaved, setEventDetailsSaved] = useState(true);
  
//     useEffect(() => {
//         dispatch(get_sellerPackages_webSiteOrigin(sellerFrontendURL))
//         //console.log('dispatch get_banners ', banners)
//     },[])

//     const [state, setState] = useState({
//         depositGiven: eventDetails?.depositGiven, eventName:'', selectedSellerPackage:'None', venueName:'', venueAddress:'', 
//         eventType: '', eventDate: '', eventStartTime: '',
//         eventServiceType: '', eventPlaceSettings: '', eventGuestTableclothColor:'',eventBuffetTableclothColor: '', eventNapkinColor: '',
//         venueManagerContactInfo: '', venueDoorCode: '', eventGuestCount: 0, eventNotes: ''
//     })

    
//     const inputHandle = (e) => {
//         //e.preventDefault()
//         //e.stopPropagation();
//         setState({
//             ...state,   
//             [e.target.name]: e.target.value
//         })
//         setEventDetailsSaved(false);
//         // console.log(state) 
//         //console.log(e.target.name) 
//         //console.log(e.target.value) 
//     }

//     const close_set_time  = (e) => {
//         e.preventDefault()
//     }

//     const [showTimePickerPopup, setShowTimePickerPopup] = useState(false);

//     const closeTimePickerPopup = () => {
//         setShowTimePickerPopup(false);
//     };

//     const openTimePickerPopup = () => {
//         setShowTimePickerPopup(true);
//     };
    
//     const update_event_details_local = (e) => {
//         e.preventDefault()
//         if (userInfo) {
//             //console.log('eventDetails?.depositGiven ', eventDetails?.depositGiven) update_event_details_not_deposit
//             dispatch(update_event_details_not_deposit({
//                 customerId: userInfo.id,
//                 //depositGiven: eventDetails?.depositGiven, // === 'true' ? 'true' : 'false',
//                 eventName: state.eventName, 
//                 selectedSellerPackage: state.selectedSellerPackage,
//                 venueName: state.venueName, 
//                 venueAddress: state.venueAddress,
//                 eventType: state.eventType, 
//                 eventDate: state.eventDate, 
//                 eventStartTime: state.eventStartTime,
//                 eventServiceType: state.eventServiceType, 
//                 eventPlaceSettings: state.eventPlaceSettings, 
//                 eventGuestTableclothColor: state.eventGuestTableclothColor, 
//                 eventBuffetTableclothColor: state.eventBuffetTableclothColor,
//                 eventNapkinColor: state.eventNapkinColor,
//                 venueManagerContactInfo: state.venueManagerContactInfo, 
//                 venueDoorCode: state.venueDoorCode,
//                 eventGuestCount: state.eventGuestCount, 
//                 eventNotes: state.eventNotes
//             }))
//             setEventDetailsSaved(true);
//         } else {
//             navigate('/login')
//         }
//     }

//     useEffect(() => {
//         setState({
//             depositGiven: eventDetails?.depositGiven, //?.toString,
//             eventName: eventDetails?.eventName, 
//             selectedSellerPackage: eventDetails?.selectedSellerPackage,
//             venueName: eventDetails?.venueName, 
//             venueAddress: eventDetails?.venueAddress,
//             eventType: eventDetails?.eventType, 
//             eventDate: eventDetails?.eventDate, 
//             eventStartTime: eventDetails?.eventStartTime,
//             eventServiceType: eventDetails?.eventServiceType, 
//             eventPlaceSettings: eventDetails?.eventPlaceSettings, 
//             eventGuestTableclothColor: eventDetails?.eventGuestTableclothColor, 
//             eventBuffetTableclothColor: eventDetails?.eventBuffetTableclothColor,
//             eventNapkinColor: eventDetails?.eventNapkinColor,
//             venueManagerContactInfo: eventDetails?.venueManagerContactInfo, 
//             venueDoorCode: eventDetails?.venueDoorCode,
//             eventGuestCount: eventDetails?.eventGuestCount, 
//             eventNotes: eventDetails?.eventNotes
//         })
//         //dispatch(messageClear())
//     }, [eventDetails])

//     // const [selectedTime, setSelectedTime] = useState(state.eventStartTime);

//     // const handleTimeChange = (newTime) => {
//     //     setSelectedTime(newTime);
//     // };

//     useEffect(() => { 
//         if (successMessage) {
//             //console.log(successMessage)
//             toast.success(successMessage)
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//    // console.log(eventName)

//     return (
//         <div>
//             <div className='border p-4 rounded-md'
//                 style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                 {
//                     // EventDetailsCustomerDashboard
//                     // deposit buy now section 83 
//                     // move felids from customer registartion to this form
//                     // section 83 depositGiven
//                 }                
//                 <form onSubmit={update_event_details_local}>
//                     <div className='flex md:flex-col md:gap-2 w-full' style={{color:sellerPrimaryColor1}}>
//                         <div className='text-2xl flex mb-2 font-bold'>
//                             <TbListDetails className='mt-1 mr-1' /> Event Details 
//                         </div>
//                         <div className={`${eventDetailsSaved ? 'bg-green-200 border-green-600' : 'bg-red-200 border-red-600'} 
//                             flex ml-2 mt-1 pl-2 pr-2 h-[30px] items-center border rounded-lg`}>
//                             <button title="Save Layout" className="pr-0 flex text-green-600 rounded">
//                                 <FiSave className='mr-1' size={20} />
//                                 <div className="flex ">
//                                     <span className={`${eventDetailsSaved ? 'hidden' : ''} text-[12px] text-red-600 font-bold`}>
//                                         Save Event Details
//                                     </span>
//                                     <span className={`${eventDetailsSaved ? '' : 'hidden'} text-[12px] text-green-600 font-bold`}>
//                                         Event Details Saved
//                                     </span>
//                                 </div>
//                             </button>
//                         </div>

//                         <div className=' hidden ml-2 mt-1'>
//                             <GiveDepositComponent />
//                         </div>
                        
//                         <input onChange={inputHandle} value={state.discount} type="number" name='' id='' placeholder='' 
//                                 className='hidden px-4 py-2 focus:border-indigo-500 outline-none border border-slate-700 rounded-md 
//                                 placeholder:text-[#6a5fdf] bg-[#bed0f5] text-[#6a5fdf]'>
//                         </input>
//                         <div className={` ${sellerEnvironment === 'Dev' ? '' : 'hidden'} text-[12px] ml-2 text-gray-500`}>
//                             <div>eventDetails?._id</div>
//                             <div>"_id": ObjectId("{eventDetails?._id}")</div>
//                             <div>sellerBoolShowSitePayments: {sellerBoolShowSitePayments.toString()}</div>
//                         </div>
//                     </div>
//                     <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="eventName">Event Name</label>
//                             <input required onChange={inputHandle} value={state.eventName} name="eventName" id="eventName" type="text" 
//                                 placeholder='Event Name e.g The Bar Mitzvah Of Ari Cohen' 
//                                 className='w-full px-3 py-1 border border-slate-200 rounded-md' /> 
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="selectedSellerPackage">Package</label>
//                             <select required onChange={inputHandle} value={state.selectedSellerPackage} name="selectedSellerPackage" id="selectedSellerPackage" 
//                                 className='w-full px-3 py-1 h-[33px] border-slate-200 rounded-md'>
//                                 <option value='None'>Choose Package/No Package</option>
//                                 {
//                                     sellerPackages.map((item, index) => 
//                                         <option key={index} value={item.title}>{item.title}</option>
//                                     )
//                                 }
//                             </select>
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="venueName">Venue Name</label>
//                             <input onChange={inputHandle} value={state.venueName} name="venueName" id="venueName" type="text" 
//                                 placeholder='Venue Name e.g Cong Adath Israel' 
//                                 className='w-full px-3 py-1 border border-slate-200 rounded-md' /> 
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="venueAddress">Venue Address</label>
//                             <input onChange={inputHandle} value={state.venueAddress} name="venueAddress" id="venueAddress"  type="text" 
//                                 placeholder='Venue Full Address, City, State, Zipcode' 
//                                 className='w-full px-3 py-1 border border-slate-200 rounded-md' /> 
//                         </div>
//                     </div>
//                     <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="venueManagerContactInfo">Venue Manager</label>
//                             <input onChange={inputHandle} value={state.venueManagerContactInfo} name="venueManagerContactInfo" id="venueManagerContactInfo" 
//                                 placeholder='Name/Phone Or N/A' type="text"
//                                 className='w-full px-3 py-1 border border-slate-200 rounded-md' /> 
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="venueDoorCode">Venue Door Code</label>
//                             <input onChange={inputHandle} value={state.venueDoorCode} name="venueDoorCode" id="venueDoorCode" 
//                                 placeholder='Venue Door Code' type="text"
//                                 className='w-full px-3 py-1 border border-slate-200 rounded-md' />
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="eventDate">Date</label>
//                             <input onChange={inputHandle} value={state.eventDate} name="eventDate" id="eventDate" 
//                                 type="date" className='w-full px-3 py-1 border border-slate-200 rounded-md' /> 
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px] flex' htmlFor="eventStartTime">
//                                 Start Time
//                                 <div className='hidden'>
//                                     <button onClick={close_set_time}
//                                         className='ml-2 px-2 py-0.5 flex text-[12px] rounded-md text-white' 
//                                         style={{backgroundColor:sellerPrimaryColor1}}>
//                                         <FaCircleCheck size={10} className='mr-0 mt-1' /> Done
//                                     </button>
//                                 </div>
//                             </label>
//                             {
//                                 //defaultValue="10:10:00 am"
//                                 // onChange={inputHandle}
//                                 // onTimeChange={inputHandle}
//                             }
//                             <div className="relative">
//                                 {/* Time input */}
//                                 <input 
//                                     onChange={inputHandle} 
//                                     value={state.eventStartTime} 
//                                     type="time" 
//                                     name="eventStartTime" 
//                                     id="eventStartTime"  
//                                     onClick={() => setShowTimePickerPopup(true)}
//                                     className='w-full cursor-pointer px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' 
//                                 />

//                                 {/* Popup */}
//                                 {showTimePickerPopup && (
//                                     <div className="absolute cursor-pointer z-10 mt-1 w-full bg-white border border-slate-200 rounded-md shadow-lg p-3">
                                        
//                                         {/* Close button inside popup */}
//                                         <div className="flex justify-end">
//                                             <button
//                                             type="button"
//                                             onClick={closeTimePickerPopup}
//                                             className="text-red-400 hover:text-red-600 font-bold"
//                                             >
//                                             Close
//                                             </button>
//                                         </div>
//                                     {/* Your popup content here */}
//                                     </div>
//                                 )}
//                             </div>
//                             {
//                             // <input onChange={inputHandle} value={state.eventStartTime} type="time" name="eventStartTime" id="eventStartTime"  
//                             //     className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' /> 
//                             }
//                         </div>   
//                     </div>
//                     <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="eventType">Event Type</label>
//                             <select required onChange={inputHandle} value={state.eventType} name="eventType" id="eventType" 
//                                 className='w-full px-3 py-1 h-[33px] border border-slate-200 rounded-md'>
//                                 <option value="">Event Type</option>
//                                 {
//                                     sellerArrEventTypes.sort().map((p, i) =>
//                                         <option key={i} value={p}>{p}</option>
//                                     )
//                                     // onChange={(e) => setCategory(e.target.value) 
//                                 }
//                             </select>
//                         </div>
                        
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="eventServiceType">Service Type</label>
//                             <select onChange={inputHandle} value={state.eventServiceType} name="eventServiceType" id="eventServiceType" 
//                                 className='w-full px-3 py-1 h-[33px] border border-slate-200 rounded-md'>
//                                 <option value="">Service Type</option>
//                                 {
//                                     sellerServiceTypes !== undefined &&
//                                         sellerServiceTypes.split(';').map((p, i) =>
//                                             <option key={i} value={p}>{p}</option>
//                                         )
//                                 }
//                             </select>
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="eventPlaceSettings">Place Settings</label>
//                             <select onChange={inputHandle} value={state.eventPlaceSettings} name="eventPlaceSettings" id="eventPlaceSettings" 
//                                 className='w-full px-3 py-1 h-[33px] border border-slate-200 rounded-md'>
//                                 <option value="">Place Settings</option>
//                                 {
//                                     sellerPlaceSettings !== undefined &&
//                                         sellerPlaceSettings.split(';').map((p, i) =>
//                                             <option key={i} value={p}>{p}</option>
//                                         )
//                                 }
//                             </select>
//                         </div>
//                     </div>
//                     <div className='flex md:flex-col md:gap-2 w-full gap-2' style={{color:sellerPrimaryColor1}}>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="eventGuestTableclothColor">Guest Tablecloth Color</label>
//                             <select onChange={inputHandle} value={state.eventGuestTableclothColor} name="eventGuestTableclothColor" id="eventGuestTableclothColor" 
//                                 className='w-full px-3 py-1 h-[33px] border border-slate-200 rounded-md'>
//                                 <option value="">Guest Tablecloth Color</option>
//                                 <option value="None">None</option>
//                                 {
//                                     sellerArrClothColors !== undefined &&
//                                         sellerArrClothColors.split(';').sort().map((p, i) =>
//                                             <option key={i} value={p}>{p}</option>
//                                         )
//                                 }
//                             </select>
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="eventBuffetTableclothColor">Buffet Tablecloth Color</label>
//                             <select onChange={inputHandle} value={state.eventBuffetTableclothColor} name="eventBuffetTableclothColor" id="eventBuffetTableclothColor" 
//                                 className='w-full px-3 py-1 h-[33px] border border-slate-200 rounded-md'>
//                                 <option value="">Buffet Tablecloth Color</option>
//                                 <option value="None">None</option>
//                                 {
//                                     sellerArrClothColors !== undefined &&
//                                         sellerArrClothColors.split(';').sort().map((p, i) =>
//                                             <option key={i} value={p}>{p}</option>
//                                         )
//                                 }   
//                             </select>
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]' htmlFor="eventNapkinColor">Napkin Color</label>
//                             <select onChange={inputHandle} value={state.eventNapkinColor} name="eventNapkinColor" id="eventNapkinColor" 
//                                 className='w-full px-3 py-1 h-[33px] border border-slate-200 outline-none focus:border-green-500 rounded-md'>
//                                 <option value="">Napkin Color</option>
//                                 <option value="None">None</option>
//                                 {
//                                     sellerArrClothColors !== undefined &&
//                                         sellerArrClothColors.split(';').sort().map((p, i) =>
//                                             <option key={i} value={p}>{p}</option>
//                                         )
//                                 }
//                             </select>
//                         </div>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-semibold text-[14px]'  htmlFor="eventGuestCount">
//                                 Guest Count <span className={`${sellerMinGuestCount === '1' ? 'hidden' : ''}`}>(Min {sellerMinGuestCount})</span>
//                             </label>
//                             <input onChange={inputHandle} value={state.eventGuestCount} type="number" min={sellerMinGuestCount} 
//                                 name="eventGuestCount" id="eventGuestCount" placeholder='How Many People Are Coming?'
//                                 className='w-full px-3 py-1 border border-slate-200 outline-none focus:border-green-500 rounded-md' /> 
//                         </div>
//                     </div>
//                     <div className='flex md:flex-col md:gap-2 w-full gap-5' style={{color:sellerPrimaryColor1}}>
//                         <div className='flex flex-col gap-1 mb-2 w-full'>
//                             <label className='font-bold'  htmlFor="eventNotes">My Notes (Optional)</label>
//                             <textarea onChange={inputHandle} value={state.eventNotes} name="eventNotes" id="eventNotes"  type="text"
//                                 placeholder="Is There Anything Else We Need To Know? Are there any food related sensitivities or preferences you'd like us to know about?" 
//                                 className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md'  />
//                         </div>
//                     </div>
//                     <div className='flex flex-col gap-1 mt-3 mb-2 w-full'>
//                         <button className='flex px-3 py-[6px] rounded-lg font-bold text-lg text-white items-center justify-center' 
//                             style={{backgroundColor:sellerPrimaryColor1}}>
//                             <TbListDetails size={'24'} className='mt-0 mr-1' /> Save Event Details
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default EventDetailsCustomerDashboard;
